import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { taxRatesQueryOptions } from '../../../../features/finance/queries'
import { EditPurchasePage } from '../../../../features/purchasing/purchase-pages'
import { salesSettingsQueryOptions } from '../../../../features/sales/queries'

export const Route = createFileRoute('/_app/purchases/$purchaseId/edit')({
  staticData: { crumb: 'purchaseEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'purchases.create'),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: EditPurchasePage,
})
